import React from 'react';
import { Award, Calendar, Building2, Clock } from 'lucide-react';
import { Badge } from '../components/ui/badge';
import Layout from '../components/layout/Layout';
import { useLanguage } from '../i18n';

function CertificationsPage() {
  const { t, getCertifications } = useLanguage();
  const certData = getCertifications();
  const obtainedList = certData.obtained;
  const inProgressList = certData.inProgress;

  return (
    <Layout>
      <section className="py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-12 lg:mb-16">
            <h1 className="section-title">{t('certifications.title')}</h1>
            <p className="font-body text-lg text-slate-600 mt-4 max-w-2xl">
              {t('certifications.description')}
            </p>
          </div>

          <div className="mb-12">
            <h2 className="font-mono text-xs uppercase tracking-wider text-slate-500 mb-6 flex items-center gap-2">
              <Award className="w-4 h-4" />
              {t('certifications.obtained')}
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {obtainedList.map(function(cert, idx) {
                return (
                  <div key={idx} className="bg-white border border-slate-200 p-6 lg:p-8">
                    <div className="flex flex-col md:flex-row gap-6">
                      <div className="flex-shrink-0 flex justify-center md:justify-start">
                        <img src={cert.badgeImage} alt={cert.name} className="w-32 h-32 object-contain" />
                      </div>
                      <div className="flex-1">
                        <Badge className="mb-3 font-mono text-xs rounded-none bg-green-100 text-green-700 border border-green-200">
                          {t('certifications.certified')}
                        </Badge>
                        <h3 className="font-display text-xl font-medium text-slate-800 mb-3">{cert.name}</h3>
                        <div className="space-y-2 text-sm text-slate-600">
                          <div className="flex items-center gap-2">
                            <Building2 className="w-4 h-4 text-slate-400" />
                            <span>{t('certifications.issuer')}: {cert.issuer}</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <Calendar className="w-4 h-4 text-slate-400" />
                            <span>{t('certifications.obtainedDate')}: {cert.obtainedDate}</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <Clock className="w-4 h-4 text-slate-400" />
                            <span>{t('certifications.expirationDate')}: {cert.expirationDate}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div>
            <h2 className="font-mono text-xs uppercase tracking-wider text-slate-500 mb-6 flex items-center gap-2">
              <Clock className="w-4 h-4" />
              {t('certifications.inProgress')}
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {inProgressList.map(function(cert, idx) {
                return (
                  <div key={idx} className="bg-white border border-slate-200 p-6 lg:p-8">
                    <Badge className="mb-3 font-mono text-xs rounded-none bg-amber-100 text-amber-700 border border-amber-200">
                      {t('certifications.inProgressStatus')}
                    </Badge>
                    <h3 className="font-display text-xl font-medium text-slate-800 mb-3">{cert.name}</h3>
                    <div className="flex items-center gap-2 text-sm text-slate-600">
                      <Building2 className="w-4 h-4 text-slate-400" />
                      <span>{t('certifications.issuer')}: {cert.issuer}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default CertificationsPage;
